var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueApexCharts',{staticClass:"col-sm-12 col-md-6 m-auto",attrs:{"type":"polarArea","options":_vm.polarAreaChart.options,"series":_vm.polarAreaChart.series}})
}
var staticRenderFns = []

export { render, staticRenderFns }